import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSave, 
    faTimes, 
    faSearch, 
    faPlus, 
    faTrash, 
    faCheck,
    faCheckDouble,
    faTimes as faClose,
    faCity,
    faFileContract 
} from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';

const id = window.location.pathname.split('/').pop()
const defaultLayout = Object.keys(DefaultLayout);
const layout = id ? id : defaultLayout

class FuecMasivo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            modalType: '',
            modalData: [],
            modalFilteredData: [],
            searchTerm: '',
            categoriaFilter: 'todos',
            categorias: [],
            selectedClientes: [],
            selectedPlacas: [],
            selectedRecorridos: [],
            selectedContratos: [],
            selectedCiudad: null,
            clientesInput: '',
            placasInput: '',
            recorridosInput: '',
            contratosInput: '',
            ciudadInput: '',
            ListaDatos: {
                clientes: [],
                vehiculos: [],
                recorridos: [],
                ciudad: [],
                contratos: [],
            },
            itemsSeleccionados: [],
            // Nuevo estado para controlar si se puede seleccionar contratos
            clientesSeleccionadosIds: []
        };
    }

    enviarDatos = (e) => {
        e.preventDefault();
        const { selectedClientes, selectedPlacas, selectedRecorridos, selectedCiudad, selectedContratos } = this.state;
        
        // Validar campos requeridos
        const validaciones = [
            { condicion: selectedClientes.length === 0, mensaje: 'Debe seleccionar al menos un cliente' },
            { condicion: selectedPlacas.length === 0, mensaje: 'Debe seleccionar al menos una placa' },
            { condicion: selectedRecorridos.length === 0, mensaje: 'Debe seleccionar al menos un recorrido' },
            { condicion: selectedContratos.length === 0, mensaje: 'Debe seleccionar al menos un contrato' },
            { condicion: !selectedCiudad, mensaje: 'Debe seleccionar una ciudad' }
        ];

        for (let validacion of validaciones) {
            if (validacion.condicion) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Campo requerido',
                    text: validacion.mensaje
                });
                return;
            }
        }

        // Confirmar antes de enviar
        Swal.fire({
            icon: 'question',
            title: '¿Confirmar envío?',
            html: `
                <strong>Resumen:</strong><br>
                Clientes: ${selectedClientes.length}<br>
                Placas: ${selectedPlacas.length}<br>
                Recorridos: ${selectedRecorridos.length}<br>
                Contratos: ${selectedContratos.length}<br>
                Ciudad: ${selectedCiudad.nombre}<br><br>
                <strong>Total combinaciones:</strong> ${selectedClientes.length * selectedPlacas.length * selectedRecorridos.length * selectedContratos.length}
            `,
            showCancelButton: true,
            confirmButtonText: 'Sí, crear',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.procesarEnvio();
            }
        });
    }

    procesarEnvio = () => {
        const { selectedClientes, selectedPlacas, selectedRecorridos, selectedCiudad, selectedContratos } = this.state;

        Swal.fire({
            title: 'Procesando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const datosEnvio = {
            clientes: selectedClientes.map(item => item.id),
            placas: selectedPlacas.map(item => item.id),
            recorridos: selectedRecorridos.map(item => item.id),
            contratos: selectedContratos.map(item => item.id),
            ciudad: selectedCiudad.id,
            usuario: localStorage.getItem('idusuario')
        };

        console.log('Datos a enviar:', datosEnvio);

        authAxios.post("fuec/insertar_masivo", datosEnvio)
            .then((response) => {
                Swal.close();
                
                if (response.data.success) {
                    const data = response.data.data || {};
                    const errores = data.errores || [];
                    
                    let mensaje = `
                        <div style="text-align: left;">
                            <strong>✅ ${response.data.message}</strong><br><br>
                            <strong>📊 Resumen:</strong><br>
                            Total FUECs creados: ${data.total_creados || 0}<br>
                        </div>
                    `;

                    if (errores.length > 0) {
                        mensaje += `<br><strong>⚠️ Advertencias (${errores.length}):</strong><br>`;
                        mensaje += errores.slice(0, 5).map(err => `• ${err}<br>`).join('');
                        
                        if (errores.length > 5) {
                            mensaje += `... y ${errores.length - 5} más<br>`;
                        }
                    }

                    Swal.fire({
                        icon: 'success',
                        title: '¡Éxito!',
                        html: mensaje,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                    }).then(() => {
                        Swal.fire({
                            icon: 'question',
                            title: '¿Qué desea hacer?',
                            showCancelButton: true,
                            confirmButtonText: 'Crear otro lote',
                            cancelButtonText: 'Ir a la lista',
                            cancelButtonColor: '#3085d6'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.limpiarFormulario();
                            } else {
                                window.location.href = `${process.env.PUBLIC_URL}/pages/28/${layout}`;
                            }
                        });
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.data.message || 'Error al crear los FUECs'
                    });
                }
            })
            .catch((error) => {
                Swal.close();
                
                let mensajeError = 'Error al conectar con el servidor';
                let detallesError = '';

                if (error.response) {
                    console.error('Error response:', error.response.data);
                    
                    if (error.response.data && error.response.data.message) {
                        mensajeError = error.response.data.message;
                    } else if (error.response.data && error.response.data.error) {
                        mensajeError = error.response.data.error;
                    }

                    if (error.response.data && error.response.data.errores) {
                        const errores = error.response.data.errores;
                        detallesError = '<br><br><strong>Detalles:</strong><br>';
                        detallesError += errores.slice(0, 10).map(err => `• ${err}<br>`).join('');
                        
                        if (errores.length > 10) {
                            detallesError += `... y ${errores.length - 10} más<br>`;
                        }
                    }

                    if (error.response.status === 422) {
                        mensajeError = 'Error de validación en los datos enviados';
                    } else if (error.response.status === 500) {
                        mensajeError = 'Error interno del servidor';
                    }
                } else if (error.request) {
                    mensajeError = 'No se recibió respuesta del servidor';
                    detallesError = '<br>Verifique su conexión a internet';
                } else {
                    mensajeError = 'Error al enviar la petición';
                }
                
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: mensajeError + (detallesError || '')
                });
            });
    }

    limpiarFormulario = () => {
        this.setState({
            selectedClientes: [],
            selectedPlacas: [],
            selectedRecorridos: [],
            selectedContratos: [],
            selectedCiudad: null,
            clientesInput: '',
            placasInput: '',
            recorridosInput: '',
            contratosInput: '',
            ciudadInput: '',
            itemsSeleccionados: [],
            clientesSeleccionadosIds: []
        });
    }

    MostrarDatos() {
        authAxios.get("cargar_datos")
            .then((datosRespuesta) => {
                Swal.close();
                
                const categorias = [...new Set(datosRespuesta.data.vehiculos.map(v => v.nombre))];
                
                this.setState({
                    ListaDatos: datosRespuesta.data,
                    categorias: categorias
                });
            })
            .catch(error => {
                console.error('Error al cargar datos:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudieron cargar los datos'
                });
            });
    }

    componentDidMount() {
        this.MostrarDatos();
    }

    abrirModal = (tipo) => {
        const { ListaDatos, selectedClientes, selectedPlacas, selectedRecorridos, selectedCiudad, selectedContratos, selectedClientes: clientesSeleccionados } = this.state;
        let data = [];
        
        switch(tipo) {
            case 'clientes':
                data = ListaDatos.clientes || [];
                break;
            case 'placas':
                data = ListaDatos.vehiculos || [];
                break;
            case 'recorridos':
                data = ListaDatos.recorridos || [];
                break;
            case 'contrato':
                // Filtrar contratos según los clientes seleccionados
                if (clientesSeleccionados.length > 0) {
                    const clientesIds = clientesSeleccionados.map(c => c.id);
                    data = (ListaDatos.contratos || []).filter(contrato => 
                        clientesIds.includes(contrato.cliente_id)
                    );
                } else {
                    data = [];
                }
                break;
            case 'ciudad':
                data = ListaDatos.ciudad || [];
                break;
            default:
                data = [];
        }

        // Validar que haya clientes seleccionados antes de abrir contratos
        if (tipo === 'contrato' && clientesSeleccionados.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Selección requerida',
                text: 'Debe seleccionar al menos un cliente antes de seleccionar contratos'
            });
            return;
        }

        // Obtener IDs ya seleccionados
        let idsSeleccionados = [];
        if (tipo === 'clientes') idsSeleccionados = selectedClientes.map(c => c.id);
        if (tipo === 'placas') idsSeleccionados = selectedPlacas.map(p => p.id);
        if (tipo === 'recorridos') idsSeleccionados = selectedRecorridos.map(r => r.id);
        if (tipo === 'contrato') idsSeleccionados = selectedContratos.map(c => c.id);
        if (tipo === 'ciudad' && selectedCiudad) idsSeleccionados = [selectedCiudad.id];

        this.setState({
            showModal: true,
            modalType: tipo,
            modalData: data,
            modalFilteredData: data,
            searchTerm: '',
            categoriaFilter: 'todos',
            itemsSeleccionados: idsSeleccionados
        });
    }

    cerrarModal = () => {
        this.setState({
            showModal: false,
            modalType: '',
            modalData: [],
            modalFilteredData: [],
            searchTerm: '',
            categoriaFilter: 'todos',
            itemsSeleccionados: []
        });
    }

    handleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        this.filtrarDatos(searchTerm, this.state.categoriaFilter);
    }

    handleCategoriaFilter = (e) => {
        const categoria = e.target.value;
        this.filtrarDatos(this.state.searchTerm, categoria);
    }

    filtrarDatos = (searchTerm, categoria) => {
        const { modalData, modalType } = this.state;

        let filtered = modalData.filter(item => {
            let matchesSearch = true;
            if (searchTerm) {
                if (modalType === 'clientes') {
                    matchesSearch = item.nombres?.toLowerCase().includes(searchTerm) || 
                                   item.apellidos?.toLowerCase().includes(searchTerm) ||
                                   item.id.toString().includes(searchTerm);
                } else if (modalType === 'placas') {
                    matchesSearch = item.placa?.toLowerCase().includes(searchTerm) ||
                                   item.id.toString().includes(searchTerm) ||
                                   item.nombre?.toLowerCase().includes(searchTerm);
                } else if (modalType === 'recorridos') {
                    matchesSearch = item.resumen?.toLowerCase().includes(searchTerm) ||
                                   item.id.toString().includes(searchTerm);
                } else if (modalType === 'contrato') {
                    matchesSearch = item.resumido?.toLowerCase().includes(searchTerm) ||
                                   item.id.toString().includes(searchTerm) ||
                                   (item.cliente_id && item.cliente_id.toString().includes(searchTerm));
                } else if (modalType === 'ciudad') {
                    matchesSearch = item.nombre?.toLowerCase().includes(searchTerm) ||
                                   item.id.toString().includes(searchTerm);
                }
            }

            let matchesCategoria = true;
            if (modalType === 'placas' && categoria !== 'todos') {
                matchesCategoria = item.nombre === categoria;
            }

            return matchesSearch && matchesCategoria;
        });

        this.setState({
            modalFilteredData: filtered,
            searchTerm,
            categoriaFilter: categoria
        });
    }

    seleccionarItem = (item) => {
        const { modalType, itemsSeleccionados, selectedClientes, selectedPlacas, selectedRecorridos, selectedCiudad, selectedContratos } = this.state;

        if (modalType === 'ciudad') {
            this.setState({
                selectedCiudad: item,
                ciudadInput: `${item.nombre} (ID: ${item.id})`,
                itemsSeleccionados: [item.id]
            });
            this.cerrarModal();
            return;
        }

        let nuevosSeleccionados = [...itemsSeleccionados];
        const itemIndex = nuevosSeleccionados.indexOf(item.id);

        if (itemIndex === -1) {
            nuevosSeleccionados.push(item.id);
            
            switch(modalType) {
                case 'clientes':
                    this.setState({
                        selectedClientes: [...selectedClientes, item],
                        clientesInput: [...selectedClientes, item].map(c => `${c.nombres} ${c.apellidos} (ID: ${c.id})`).join(', '),
                        // Limpiar contratos al cambiar los clientes seleccionados
                        selectedContratos: [],
                        contratosInput: ''
                    });
                    break;
                case 'placas':
                    this.setState({
                        selectedPlacas: [...selectedPlacas, item],
                        placasInput: [...selectedPlacas, item].map(p => `${p.placa} (${p.nombre}) (ID: ${p.id})`).join(', ')
                    });
                    break;
                case 'recorridos':
                    this.setState({
                        selectedRecorridos: [...selectedRecorridos, item],
                        recorridosInput: [...selectedRecorridos, item].map(r => `${r.resumen.substring(0, 50)}... (ID: ${r.id})`).join(', ')
                    });
                    break;
                case 'contrato':
                    this.setState({
                        selectedContratos: [...selectedContratos, item],
                        contratosInput: [...selectedContratos, item].map(c => `${c.resumido} (ID: ${c.id})`).join(', ')
                    });
                    break;
                default:
                    break;
            }
        } else {
            nuevosSeleccionados.splice(itemIndex, 1);
            
            switch(modalType) {
                case 'clientes':
                    const nuevosClientes = selectedClientes.filter(c => c.id !== item.id);
                    this.setState({
                        selectedClientes: nuevosClientes,
                        clientesInput: nuevosClientes.map(c => `${c.nombres} ${c.apellidos} (ID: ${c.id})`).join(', '),
                        // Limpiar contratos al cambiar los clientes seleccionados
                        selectedContratos: [],
                        contratosInput: ''
                    });
                    break;
                case 'placas':
                    const nuevasPlacas = selectedPlacas.filter(p => p.id !== item.id);
                    this.setState({
                        selectedPlacas: nuevasPlacas,
                        placasInput: nuevasPlacas.map(p => `${p.placa} (${p.nombre}) (ID: ${p.id})`).join(', ')
                    });
                    break;
                case 'recorridos':
                    const nuevosRecorridos = selectedRecorridos.filter(r => r.id !== item.id);
                    this.setState({
                        selectedRecorridos: nuevosRecorridos,
                        recorridosInput: nuevosRecorridos.map(r => `${r.resumen.substring(0, 50)}... (ID: ${r.id})`).join(', ')
                    });
                    break;
                case 'contrato':
                    const nuevosContratos = selectedContratos.filter(c => c.id !== item.id);
                    this.setState({
                        selectedContratos: nuevosContratos,
                        contratosInput: nuevosContratos.map(c => `${c.resumido} (ID: ${c.id})`).join(', ')
                    });
                    break;
                default:
                    break;
            }
        }

        this.setState({
            itemsSeleccionados: nuevosSeleccionados
        });
    }

    seleccionarTodos = () => {
        const { modalType, modalFilteredData, selectedClientes, selectedPlacas, selectedRecorridos, selectedContratos } = this.state;

        if (modalType === 'ciudad') return;

        const todosIds = modalFilteredData.map(item => item.id);
        const nuevosIds = [...new Set([...this.state.itemsSeleccionados, ...todosIds])];
        
        switch(modalType) {
            case 'clientes':
                const todosClientes = modalFilteredData.filter(item => 
                    !selectedClientes.some(c => c.id === item.id)
                );
                this.setState({
                    selectedClientes: [...selectedClientes, ...todosClientes],
                    clientesInput: [...selectedClientes, ...todosClientes].map(c => `${c.nombres} ${c.apellidos} (ID: ${c.id})`).join(', '),
                    itemsSeleccionados: nuevosIds,
                    // Limpiar contratos al cambiar los clientes seleccionados
                    selectedContratos: [],
                    contratosInput: ''
                });
                break;
            case 'placas':
                const todasPlacas = modalFilteredData.filter(item => 
                    !selectedPlacas.some(p => p.id === item.id)
                );
                this.setState({
                    selectedPlacas: [...selectedPlacas, ...todasPlacas],
                    placasInput: [...selectedPlacas, ...todasPlacas].map(p => `${p.placa} (${p.nombre}) (ID: ${p.id})`).join(', '),
                    itemsSeleccionados: nuevosIds
                });
                break;
            case 'recorridos':
                const todosRecorridos = modalFilteredData.filter(item => 
                    !selectedRecorridos.some(r => r.id === item.id)
                );
                this.setState({
                    selectedRecorridos: [...selectedRecorridos, ...todosRecorridos],
                    recorridosInput: [...selectedRecorridos, ...todosRecorridos].map(r => `${r.resumen.substring(0, 50)}... (ID: ${r.id})`).join(', '),
                    itemsSeleccionados: nuevosIds
                });
                break;
            case 'contrato':
                const todosContratos = modalFilteredData.filter(item => 
                    !selectedContratos.some(c => c.id === item.id)
                );
                this.setState({
                    selectedContratos: [...selectedContratos, ...todosContratos],
                    contratosInput: [...selectedContratos, ...todosContratos].map(c => `${c.resumido} (ID: ${c.id})`).join(', '),
                    itemsSeleccionados: nuevosIds
                });
                break;
            default:
                break;
        }
    }

    quitarSeleccion = (index, tipo) => {
        const { selectedClientes, selectedPlacas, selectedRecorridos, selectedContratos } = this.state;

        switch(tipo) {
            case 'clientes':
                const nuevosClientes = selectedClientes.filter((_, i) => i !== index);
                this.setState({
                    selectedClientes: nuevosClientes,
                    clientesInput: nuevosClientes.map(c => `${c.nombres} ${c.apellidos} (ID: ${c.id})`).join(', '),
                    // Limpiar contratos al cambiar los clientes seleccionados
                    selectedContratos: [],
                    contratosInput: ''
                });
                break;
            case 'placas':
                const nuevasPlacas = selectedPlacas.filter((_, i) => i !== index);
                this.setState({
                    selectedPlacas: nuevasPlacas,
                    placasInput: nuevasPlacas.map(p => `${p.placa} (${p.nombre}) (ID: ${p.id})`).join(', ')
                });
                break;
            case 'recorridos':
                const nuevosRecorridos = selectedRecorridos.filter((_, i) => i !== index);
                this.setState({
                    selectedRecorridos: nuevosRecorridos,
                    recorridosInput: nuevosRecorridos.map(r => `${r.resumen.substring(0, 50)}... (ID: ${r.id})`).join(', ')
                });
                break;
            case 'contrato':
                const nuevosContratos = selectedContratos.filter((_, i) => i !== index);
                this.setState({
                    selectedContratos: nuevosContratos,
                    contratosInput: nuevosContratos.map(c => `${c.resumido} (ID: ${c.id})`).join(', ')
                });
                break;
            default:
                break;
        }
    }

    quitarCiudad = () => {
        this.setState({
            selectedCiudad: null,
            ciudadInput: ''
        });
    }

    renderTabla = () => {
        const { modalType, modalFilteredData, itemsSeleccionados } = this.state;

        if (modalType === 'clientes') {
            return (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th width="50">ID</th>
                            <th>Nombres</th>
                            <th>Apellidos</th>
                            <th width="50">Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modalFilteredData.map((item) => (
                            <tr key={item.id} className={itemsSeleccionados.includes(item.id) ? 'table-primary' : ''}>
                                <td>{item.id}</td>
                                <td>{item.nombres}</td>
                                <td>{item.apellidos}</td>
                                <td className="text-center">
                                    <input 
                                        type="checkbox"
                                        checked={itemsSeleccionados.includes(item.id)}
                                        onChange={() => this.seleccionarItem(item)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            );
        } else if (modalType === 'placas') {
            return (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th width="50">ID</th>
                            <th>Placa</th>
                            <th>Categoría</th>
                            <th width="50">Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modalFilteredData.map((item) => (
                            <tr key={item.id} className={itemsSeleccionados.includes(item.id) ? 'table-primary' : ''}>
                                <td>{item.id}</td>
                                <td>{item.placa}</td>
                                <td>
                                    <Badge bg="info">{item.nombre}</Badge>
                                </td>
                                <td className="text-center">
                                    <input 
                                        type="checkbox"
                                        checked={itemsSeleccionados.includes(item.id)}
                                        onChange={() => this.seleccionarItem(item)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            );
        } else if (modalType === 'recorridos') {
            return (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th width="50">ID</th>
                            <th>Resumen</th>
                            <th width="50">Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modalFilteredData.map((item) => (
                            <tr key={item.id} className={itemsSeleccionados.includes(item.id) ? 'table-primary' : ''}>
                                <td>{item.id}</td>
                                <td>{item.resumen}</td>
                                <td className="text-center">
                                    <input 
                                        type="checkbox"
                                        checked={itemsSeleccionados.includes(item.id)}
                                        onChange={() => this.seleccionarItem(item)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            );
        } else if (modalType === 'contrato') {
            return (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th width="50">ID</th>
                            <th>Descripción del Contrato</th>
                            <th width="100">Cliente ID</th>
                            <th width="50">Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modalFilteredData.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center text-muted">
                                    No hay contratos disponibles para los clientes seleccionados
                                </td>
                            </tr>
                        ) : (
                            modalFilteredData.map((item) => (
                                <tr key={item.id} className={itemsSeleccionados.includes(item.id) ? 'table-primary' : ''}>
                                    <td>{item.id}</td>
                                    <td>{item.resumido}</td>
                                    <td>{item.cliente_id || 'N/A'}</td>
                                    <td className="text-center">
                                        <input 
                                            type="checkbox"
                                            checked={itemsSeleccionados.includes(item.id)}
                                            onChange={() => this.seleccionarItem(item)}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            );
        } else if (modalType === 'ciudad') {
            return (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th width="50">ID</th>
                            <th>Nombre de la Ciudad</th>
                            <th width="50">Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modalFilteredData.map((item) => (
                            <tr key={item.id} className={itemsSeleccionados.includes(item.id) ? 'table-primary' : ''}>
                                <td>{item.id}</td>
                                <td>{item.nombre}</td>
                                <td className="text-center">
                                    <input 
                                        type="radio"
                                        name="ciudadSelect"
                                        checked={itemsSeleccionados.includes(item.id)}
                                        onChange={() => this.seleccionarItem(item)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            );
        }
    }

    render() {
        const { 
            showModal, 
            modalType, 
            searchTerm,
            categoriaFilter,
            categorias,
            selectedClientes,
            selectedPlacas,
            selectedRecorridos,
            selectedContratos,
            selectedCiudad,
            clientesInput,
            placasInput,
            recorridosInput,
            contratosInput,
            ciudadInput
        } = this.state;

        return (
            <div className="content-wrapper">
                <Modal show={showModal} onHide={this.cerrarModal} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FontAwesomeIcon icon={faSearch} className="me-2" />
                            Seleccionar {modalType === 'clientes' ? 'Clientes' : 
                                      modalType === 'placas' ? 'Vehículos' : 
                                      modalType === 'recorridos' ? 'Recorridos' : 
                                      modalType === 'contrato' ? 'Contratos' : 'Ciudad'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row mb-3">
                            <div className={modalType === 'placas' ? "col-md-6" : "col-md-10"}>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar..."
                                        value={searchTerm}
                                        onChange={this.handleSearch}
                                    />
                                </InputGroup>
                            </div>
                            {modalType === 'placas' && (
                                <div className="col-md-4">
                                    <Form.Select 
                                        value={categoriaFilter} 
                                        onChange={this.handleCategoriaFilter}
                                    >
                                        <option value="todos">Todas las categorías</option>
                                        {categorias.map(cat => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            )}
                            {modalType !== 'ciudad' && modalType !== 'contrato' && (
                                <div className="col-md-2">
                                    <Button 
                                        variant="success" 
                                        size="sm"
                                        onClick={this.seleccionarTodos}
                                        className="w-100"
                                    >
                                        <FontAwesomeIcon icon={faCheckDouble} className="me-2" />
                                        Seleccionar Todos
                                    </Button>
                                </div>
                            )}
                        </div>
                        
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {this.renderTabla()}
                            
                            {this.state.modalFilteredData.length === 0 && modalType !== 'contrato' && (
                                <div className="text-center text-muted p-4">
                                    No se encontraron resultados
                                </div>
                            )}
                        </div>

                        <div className="mt-3 text-end">
                            <Badge bg="primary">
                                {modalType === 'ciudad' ? 'Ciudad seleccionada' : 'Seleccionados'}: {this.state.itemsSeleccionados.length}
                            </Badge>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.cerrarModal}>
                            <FontAwesomeIcon icon={faClose} className="me-2" />
                            Cerrar
                        </Button>
                        {modalType !== 'ciudad' && (
                            <Button variant="primary" onClick={this.cerrarModal}>
                                <FontAwesomeIcon icon={faCheck} className="me-2" />
                                Aceptar
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>

                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRAR FUEC MASIVOS</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                {/* Ciudad */}
                                                <div className="col-md-3">
                                                    <label htmlFor="ciudad">Ciudad <span className="text-danger">*</span></label>
                                                    <div className="input-group">
                                                        <input 
                                                            className="form-control form-control-sm" 
                                                            type="text" 
                                                            name="ciudad" 
                                                            id="ciudad" 
                                                            placeholder="Seleccione una ciudad" 
                                                            value={ciudadInput}
                                                            readOnly
                                                        />
                                                        <button 
                                                            className="btn btn-primary btn-sm" 
                                                            type="button"
                                                            onClick={() => this.abrirModal('ciudad')}
                                                        >
                                                            <FontAwesomeIcon icon={faCity} />
                                                        </button>
                                                    </div>
                                                    {selectedCiudad && (
                                                        <div className="mt-2">
                                                            <span className="badge bg-secondary me-1 mb-1" style={{ fontSize: '11px' }}>
                                                                {selectedCiudad.nombre}
                                                                <FontAwesomeIcon 
                                                                    icon={faTimes} 
                                                                    className="ms-1" 
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={this.quitarCiudad}
                                                                />
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Clientes */}
                                                <div className="col-md-3">
                                                    <label htmlFor="clientes">Clientes <span className="text-danger">*</span></label>
                                                    <div className="input-group">
                                                        <input 
                                                            className="form-control form-control-sm" 
                                                            type="text" 
                                                            name="clientes" 
                                                            id="clientes" 
                                                            placeholder="Seleccione clientes" 
                                                            value={clientesInput}
                                                            readOnly
                                                        />
                                                        <button 
                                                            className="btn btn-primary btn-sm" 
                                                            type="button"
                                                            onClick={() => this.abrirModal('clientes')}
                                                        >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </button>
                                                    </div>
                                                    {selectedClientes.length > 0 && (
                                                        <div className="mt-2" style={{ maxHeight: '100px', overflowY: 'auto' }}>
                                                            {selectedClientes.map((cliente, index) => (
                                                                <span key={cliente.id} className="badge bg-info me-1 mb-1" style={{ fontSize: '11px' }}>
                                                                    {cliente.nombres} {cliente.apellidos}
                                                                    <FontAwesomeIcon 
                                                                        icon={faTimes} 
                                                                        className="ms-1" 
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => this.quitarSeleccion(index, 'clientes')}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Contratos - Ahora al lado de Clientes */}
                                                <div className="col-md-3">
                                                    <label htmlFor="contratos">Contratos <span className="text-danger">*</span></label>
                                                    <div className="input-group">
                                                        <input 
                                                            className="form-control form-control-sm" 
                                                            type="text" 
                                                            name="contratos" 
                                                            id="contratos" 
                                                            placeholder={selectedClientes.length === 0 ? "Primero seleccione clientes" : "Seleccione contratos"} 
                                                            value={contratosInput}
                                                            readOnly
                                                            disabled={selectedClientes.length === 0}
                                                        />
                                                        <button 
                                                            className="btn btn-primary btn-sm" 
                                                            type="button"
                                                            onClick={() => this.abrirModal('contrato')}
                                                            disabled={selectedClientes.length === 0}
                                                        >
                                                            <FontAwesomeIcon icon={faFileContract} />
                                                        </button>
                                                    </div>
                                                    {selectedClientes.length === 0 && (
                                                        <small className="text-muted">
                                                            <FontAwesomeIcon icon={faTimes} className="me-1" />
                                                            Seleccione cliente(s) primero
                                                        </small>
                                                    )}
                                                    {selectedContratos.length > 0 && (
                                                        <div className="mt-2" style={{ maxHeight: '100px', overflowY: 'auto' }}>
                                                            {selectedContratos.map((contrato, index) => (
                                                                <span key={contrato.id} className="badge bg-secondary me-1 mb-1" style={{ fontSize: '11px' }}>
                                                                    {contrato.resumido.length > 40 ? `${contrato.resumido.substring(0, 40)}...` : contrato.resumido}
                                                                    <FontAwesomeIcon 
                                                                        icon={faTimes} 
                                                                        className="ms-1" 
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => this.quitarSeleccion(index, 'contrato')}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Placas */}
                                                <div className="col-md-3">
                                                    <label htmlFor="placas">Placas <span className="text-danger">*</span></label>
                                                    <div className="input-group">
                                                        <input 
                                                            className="form-control form-control-sm" 
                                                            type="text" 
                                                            name="placas" 
                                                            id="placas" 
                                                            placeholder="Seleccione placas" 
                                                            value={placasInput}
                                                            readOnly
                                                        />
                                                        <button 
                                                            className="btn btn-primary btn-sm" 
                                                            type="button"
                                                            onClick={() => this.abrirModal('placas')}
                                                        >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </button>
                                                    </div>
                                                    {selectedPlacas.length > 0 && (
                                                        <div className="mt-2" style={{ maxHeight: '100px', overflowY: 'auto' }}>
                                                            {selectedPlacas.map((placa, index) => (
                                                                <span key={placa.id} className="badge bg-success me-1 mb-1" style={{ fontSize: '11px' }}>
                                                                    {placa.placa} ({placa.nombre})
                                                                    <FontAwesomeIcon 
                                                                        icon={faTimes} 
                                                                        className="ms-1" 
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => this.quitarSeleccion(index, 'placas')}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Recorridos */}
                                                <div className="col-md-3 mt-3">
                                                    <label htmlFor="recorridos">Recorridos <span className="text-danger">*</span></label>
                                                    <div className="input-group">
                                                        <input 
                                                            className="form-control form-control-sm" 
                                                            type="text" 
                                                            name="recorridos" 
                                                            id="recorridos" 
                                                            placeholder="Seleccione recorridos" 
                                                            value={recorridosInput}
                                                            readOnly
                                                        />
                                                        <button 
                                                            className="btn btn-primary btn-sm" 
                                                            type="button"
                                                            onClick={() => this.abrirModal('recorridos')}
                                                        >
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </button>
                                                    </div>
                                                    {selectedRecorridos.length > 0 && (
                                                        <div className="mt-2" style={{ maxHeight: '100px', overflowY: 'auto' }}>
                                                            {selectedRecorridos.map((recorrido, index) => (
                                                                <span key={recorrido.id} className="badge bg-warning text-dark me-1 mb-1" style={{ fontSize: '11px' }}>
                                                                    #{recorrido.id} - {recorrido.resumen.substring(0, 30)}...
                                                                    <FontAwesomeIcon 
                                                                        icon={faTimes} 
                                                                        className="ms-1" 
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => this.quitarSeleccion(index, 'recorridos')}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group">
                                                <button type="submit" className="btn btn-success btn-sm">
                                                    <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Fuec Masivo
                                                </button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/pages/28/${layout}`}>
                                                    <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FuecMasivo;